import { ReactiveControllerHost, ReactiveController } from 'lit';
import tailwindThemeConfig from '../resolved-tailwind-config';
//TODO: add functionality to receive array of screen sizes to map to object in controller state
export class MobileControllerLegacy implements ReactiveController {
  isXl = false;
  isLg = false;
  isMobile = false;
  host: ReactiveControllerHost;

  constructor(host: ReactiveControllerHost) {
    (this.host = host).addController(this);
    this.handleResize();
  }

  hostConnected() {
    window.addEventListener('resize', this.handleResize);
  }

  hostDisconnected() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const tailwindXlScreen = this.formatScreenSize(
      tailwindThemeConfig.screens.xl
    );
    const tailwindLgScreen = this.formatScreenSize(
      tailwindThemeConfig.screens.lg
    );
    const tailwindMdScreen = this.formatScreenSize(
      tailwindThemeConfig.screens.md
    );

    if (window.innerWidth >= tailwindXlScreen) {
      this.isMobile = false;
      this.isLg = false;
      this.isXl = true;
    } else {
      this.isXl = false;
    }

    if (
      window.innerWidth >= tailwindLgScreen &&
      window.innerWidth < tailwindXlScreen
    ) {
      this.isMobile = false;
      this.isLg = true;
      this.isXl = false;
    } else {
      this.isLg = false;
    }

    if (window.innerWidth < tailwindMdScreen) {
      this.isMobile = true;
      this.isLg = false;
      this.isXl = false;
    } else {
      this.isMobile = false;
    }
    this.host.requestUpdate();
  };

  formatScreenSize = (screen: string): number => {
    return parseInt(screen.slice(0, -2));
  };
}
